<div class="form-group row" >
	<label class="control-label col-md-1">N° PA</label>
	<div class="col-md-2" *ngIf="documentPa" 
		[ngClass]="{'highlightable': !documentPa.numeroPa }">
		<input id="numeroPa" type="text" placeholder="N° PA" [disabled]="documentPa | disablePaField"
			class="form-control" [(ngModel)]="documentPa.numeroPa"
			(change)="evaluerFormulaire()" />
	</div>
</div>

<pannel [title]="'Site et lieu(x) de l\'opération'">
<div class="form-group row">
	<label class="control-label col-md-1">Parc*</label>
	<div class="col-md-5" *ngIf="documentPa" 
		[ngClass]="{'highlightable': !(documentPa.parcIds && documentPa.parcIds.length > 0)}">
		<parc-by-groupement-multi-selector [id]="'choixParcs'"
			[antenneId]="antenneId ? antenneId : null"
			[energie]="documentPa.duplicatedId ? (documentPa.categorie === paCategories.EOL ? 'Eolienne' : 'Solaire') : null"
			[disabled]="documentPa.id !== -1"
			[(selectedParcIds)]="documentPa.parcIds"
			(selectedParcIdsChange)="parcIdshasChanged($event)">
		</parc-by-groupement-multi-selector>
		<span class="text-danger message-responsables" *ngIf="differentResponsables$ | async">
			Choix incompatibles : Les parcs que vous avez sélectionnés n'ont pas le même responsable.
		</span>
	</div>

	<label class="control-label col-md-1">Commune*</label>
	<div class="col-md-3" *ngIf="documentPa" 
		[ngClass]="{'highlightable': !(documentPa.commune)}">
		<input id="CommuneId" type="text" class="form-control" [disabled]="documentPa | disablePaField"
			(change)="evaluerFormulaire()" [(ngModel)]="documentPa.commune" />
	</div>

</div>
</pannel>

<pannel [title]="'Planning'">
<div class="form-group row">
	<label class="control-label col-md-2">Date de début*</label>
	<div class="col-md-2" *ngIf="documentPa" 
		[ngClass]="{'highlightable': !documentPa.dateDebut}">
		<date-input [id]="'dateDebut'" [(localDate)]="documentPa.dateDebut" [disabled]="documentPa | disablePaField"
			[localDateMin]="borneInfDebut" [localDateMax]="borneSupDebut"
			(localDateChange)="evaluerDuree()"></date-input>
	</div>

</div>

<div class="form-group row">
	<label class="control-label col-md-2">Date de fin*</label>
	<div class="col-md-2" *ngIf="documentPa" 
		[ngClass]="{'highlightable': !documentPa.dateFin}">
		<date-input [id]="'dateFin'" [(localDate)]="documentPa.dateFin" [disabled]="documentPa | disablePaField"
			[localDateMin]="borneInfFin" [localDateMax]="borneSupFin" (localDateChange)="evaluerDuree()"></date-input>
	</div>

</div>

<div class="form-group row">
	<label class="control-label col-md-2">Horaires de travail*</label>
	<div class="col-md-4" *ngIf="documentPa" 
		[ngClass]="{'highlightable': !documentPa.horaires}">
		<input id="horaires" type="text" class="form-control"
			(change)="evaluerFormulaire()" [(ngModel)]="documentPa.horaires" [disabled]="documentPa | disablePaField"/>
	</div>

</div>

<div class="form-group row">
	<label class="control-label col-md-2">Nb prévisible d’intervenants*</label>
	<div class="col-md-2" *ngIf="documentPa" 
		[ngClass]="{'highlightable': documentPa.nombreIntervenants == null}">
		<input id="nbIntervenants" type="number" class="form-control" min="0"
			(change)="evaluerFormulaire()"
			[(ngModel)]="documentPa.nombreIntervenants" [disabled]="documentPa | disablePaField"/>
	</div>

</div>
</pannel>

<pannel [title]="'Description de l\'opération'">
<div class="form-group row">
	<div class="col-md-12" *ngIf="documentPa" >
		<textarea class="form-control" rows="4" [disabled]="documentPa | disablePaField"
			[(ngModel)]="documentPa.description"
			placeholder="Liste d’exemples non exhaustive : suivi environnemental au sol (mortalité, activité …), entretien paysager et débroussaillage « non dangereux »">
    </textarea>
	</div>
</div>
</pannel>

<pannel [title]="'Pré-requis à l\'utilisation de ce document'">
<ul class="prerequis-list">
	<li>
		<label class="checkbox-inline">
			<input id="prerequisHeures" type="checkbox" [(ngModel)]="prerequisChecked[0]"
				(change)="onPrerequisChange()" [disabled]="documentPa | disablePaField" />
			<span>Nombre total d'heures de travail prévisible < 400 heures sur une période ≤ 12 mois, que les travaux soient continus ou discontinus</span>
		</label>
	</li>
	<li>
		<label class="checkbox-inline">
			<input id="prerequisTravauxDangereux" type="checkbox" [(ngModel)]="prerequisChecked[1]"
				(change)="onPrerequisChange()" [disabled]="documentPa | disablePaField" />
			<span>Les travaux à accomplir <b>ne figurent pas sur la liste des travaux dangereux</b> fixée, respectivement, par arrêté du ministre chargé du travail et par arrêté du ministre chargé de l'agriculture (arrêté du 19 mars 1993). <b>Attention particulière au risque chimique, risque électrique et risque hauteur.</b></span>
		</label>
	</li>
	<li>
		<label class="checkbox-inline">
			<input id="prerequisCoactivite" type="checkbox" [(ngModel)]="prerequisChecked[2]"
				(change)="onPrerequisChange()" [disabled]="documentPa | disablePaField" />
			<span>Il ne doit pas y avoir de risques liés à la coactivité.</span>
		</label>
	</li>
	<li>
		<label class="checkbox-inline">
			<input id="prerequisEntretienPaysager" type="checkbox" [(ngModel)]="prerequisChecked[3]"
				(change)="onPrerequisChange()" [disabled]="documentPa | disablePaField" />
			<span>Si entretien paysager et débroussaillage, ils sont « non dangereux » = à évaluer selon les travaux à réaliser et les produits / matériels &amp; engins mis en oeuvre. Entre autres, il ne doit pas y avoir&nbsp;:</span>
		</label>
		<ul>
			<li>Exposition à des substances dangereuses</li>
			<li>Contact avec des pièces nues sous tension > TBT</li>
			<li>Utilisation d'équipements de travail auxquels est applicable l'article R. 4323-17 du Code du Travail</li>
			<li>Risque de chute de hauteur</li>
			<li>Exposition sonore quotidienne > 90 dB(A)</li>
		</ul>
	</li>
</ul>
</pannel>

<document-pa-step-actions [documentPaButtons]="actionButtons" *ngIf="documentPa" (onButtonPressed)="performAction($event)"></document-pa-step-actions>
